export default {
  GET_ALL: `#graphql
  query getChangeReasons {
    getChangeReasons {
      index
      reason
    }
  }`
}



// WEBPACK FOOTER //
// ./src/graphql/changeReason.js